import { LinkKind } from 'bloko/blocks/link';

export default [
    {
        url: 'https://hh.ru/article/2',
        anchor: 'footer.applicantLinks.article.2',
        kind: LinkKind.Tertiary,
    },
    {
        url: 'https://hh.ru/applicant/services?from=footer',
        anchor: 'footer.applicantLinks.services',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/article/1150',
        anchor: 'footer.applicantLinks.article.2',
        kind: LinkKind.Secondary,
    },
];
